
import { defineComponent } from "vue";
import DropDownSection from "@/components/sections/DropDownSections.vue";

export default defineComponent({
  name: "step-6",
  components: {DropDownSection,},
  setup() {
    const listDropDownSections = [
         {title: "Information", descriptions: [{description:
          " Some Information" }
        ]},
         
    ];
    return {
      listDropDownSections,
    };
  },
});
